import { PointPaidDto } from "..";
import { usePointPaid } from "../hook/usePointPaid";
import {
  PointPaidTableItemWrapper,
  PointPaidItemButton,
  PointPaidItemPrize,
  PointPaidItemSubPrizeWrapper,
} from "../style";
import { useEffect, useState } from "react";
import TicketSelectPopup from "./ticket-select-popup";
import { SellerHasTournamentTicketListResponse } from "../../../../../api/tournament-ticket";

interface PrizeTableRowProps {
  item: PointPaidDto;
  index: number;
  isGTD: boolean;
  hook: ReturnType<typeof usePointPaid>;
}

const getPaidSum = (prizeItem: PointPaidDto) => {
  return (
    (prizeItem.seedPrize || 0) +
    (prizeItem.pointPrize || 0) +
    (prizeItem.carrotPrize || 0) +
    (prizeItem.subPrize?.prizeValue || 0) * (prizeItem.subPrizeCount || 0)
  );
};

const PointPaidItem = ({ item, index, isGTD, hook }: PrizeTableRowProps) => {
  const [totalPrize, setTotalPrize] = useState(0);
  const [pointPrize, setPointPrize] = useState(0);
  const [carrotPrize, setCarrotPrize] = useState(0);
  const [seedPrize, setSeedPrize] = useState(0);
  const [isTicketPopupOpen, setIsTicketPopupOpen] = useState(false);
  const {
    allPrizeList,
    setAllPrizeList,
    subPrizeList,
    handleUserPointReset,
    handleUserPointPay,
    handleNicknameClick,
    setLocalStorage,
  } = hook;

  const handleButtonClick = () => {
    if (item.payMent) {
      handleUserPointReset(item);
      return;
    }

    const nextItem = {
      ...item,
      seedPrize: seedPrize || 0,
      carrotPrize: carrotPrize || 0,
      pointPrize: pointPrize || 0,
    };

    if (getPaidSum(nextItem) !== nextItem.totalPrize) {
      alert(
        "매장이용권 + 캐럿 + 래빗 + 부상 합계가 토탈 프라이즈와 일치해야 합니다.",
      );
      return;
    }

    const list = [...allPrizeList];
    list[index] = nextItem;
    setAllPrizeList(list);
    handleUserPointPay(nextItem);
  };

  const handleSubPrizeSelect = (
    subPrize: SellerHasTournamentTicketListResponse | null,
  ) => {
    const list = [...allPrizeList];
    list[index].subPrize = subPrize;
    list[index].subPrizeCount = 0;
    setAllPrizeList(list);
    setLocalStorage(list);
    setIsTicketPopupOpen(false);
  };

  const handleSubPrizeCount = (isAdd: boolean) => {
    const current = allPrizeList[index];
    if (!current.subPrize || current.payMent) return;

    const count = isAdd ? 1 : -1;
    const editCount = current.subPrizeCount + count;
    if (editCount < 0) return;

    if (editCount > current.subPrize.count) {
      alert(`보유 수량(${current.subPrize.count}장)을 초과할 수 없습니다.`);
      return;
    }

    const selectedSubPrize = current.subPrize.prizeValue || 0;
    if (editCount * selectedSubPrize > current.totalPrize) {
      alert("기존 시상 수량보다 크게 설정할 수 없습니다.");
      return;
    }

    const list = [...allPrizeList];
    list[index].subPrizeCount = editCount;
    setAllPrizeList(list);
    setLocalStorage(list);
  };

  useEffect(() => {
    setTimeout(() => {
      setTotalPrize(item.totalPrize);
      setPointPrize(item.pointPrize || 0);
      setCarrotPrize(item.carrotPrize || 0);
      setSeedPrize(item.seedPrize || 0);
    }, 150);
  }, [item]);

  return (
    <>
      <PointPaidTableItemWrapper>
        <div className="rank">{item.rank}</div>
        <PointPaidItemPrize>
          {isGTD ? (
            <div className="value">
              {item.totalPrize?.toLocaleString()} RABBIT
            </div>
          ) : (
            <input
              value={totalPrize}
              onChange={(e) => {
                const prizes = [...allPrizeList];
                prizes[index].totalPrize = +e.target.value;
                setAllPrizeList(prizes);
                setLocalStorage(prizes);
                setTotalPrize(+e.target.value);
              }}
              disabled={item.payMent}
            />
          )}
        </PointPaidItemPrize>
        <PointPaidItemPrize>
          <input
            value={pointPrize}
            onChange={(e) => {
              const prizes = [...allPrizeList];
              prizes[index].pointPrize = +e.target.value;
              setAllPrizeList(prizes);
              setLocalStorage(prizes);
              setPointPrize(+e.target.value);
            }}
            disabled={item.payMent}
          />
        </PointPaidItemPrize>
        <PointPaidItemPrize>
          <input
            value={carrotPrize}
            placeholder="CR"
            onChange={(e) => {
              const value = +e.target.value;
              if (Number.isNaN(value) || value < 0) return;
              const prizes = [...allPrizeList];
              prizes[index].carrotPrize = value;
              setAllPrizeList(prizes);
              setLocalStorage(prizes);
              setCarrotPrize(value);
            }}
            disabled={item.payMent}
          />
        </PointPaidItemPrize>
        <PointPaidItemPrize>
          <div
            className={`value ${!item.payMent && "edit"}`}
            onClick={() => {
              if (item.payMent) return;
              setIsTicketPopupOpen(true);
            }}
          >
            {item.subPrize ? item.subPrize.name : "부상 선택"}
            <span>▾</span>
          </div>
        </PointPaidItemPrize>
        <PointPaidItemPrize>
          <PointPaidItemSubPrizeWrapper>
            <div
              className="sub-prize-button"
              onClick={() => handleSubPrizeCount(false)}
            >
              -
            </div>
            <span>{item.subPrizeCount || 0}</span>
            <div
              className="sub-prize-button"
              onClick={() => handleSubPrizeCount(true)}
            >
              +
            </div>
          </PointPaidItemSubPrizeWrapper>
        </PointPaidItemPrize>
        <PointPaidItemPrize>
          <input
            value={seedPrize}
            onChange={(e) => {
              const value = +e.target.value;
              if (Number.isNaN(value) || value < 0) return;
              const prizes = [...allPrizeList];
              prizes[index].seedPrize = value;
              setAllPrizeList(prizes);
              setLocalStorage(prizes);
              setSeedPrize(value);
            }}
            disabled={item.payMent}
          />
        </PointPaidItemPrize>
        <div
          className={`nickname ${item.memberId ? "active" : ""}`}
          onClick={() => {
            if (!item.payMent) {
              handleNicknameClick(index);
            }
          }}
        >
          {item.nickname ? item.nickname : "검색"}
        </div>
        <PointPaidItemButton onClick={handleButtonClick}>
          {item.payMent ? (
            <div className="refresh">
              <img src="/image-web/solution/refresh.svg" alt="refresh" />
            </div>
          ) : (
            <div className="button">지급</div>
          )}
        </PointPaidItemButton>
      </PointPaidTableItemWrapper>

      {isTicketPopupOpen && (
        <TicketSelectPopup
          list={subPrizeList}
          selectedId={item.subPrize?.id ?? null}
          onClose={() => setIsTicketPopupOpen(false)}
          onSelect={handleSubPrizeSelect}
        />
      )}
    </>
  );
};

export default PointPaidItem;
